<template>
  <div>
    <v-layout class="text-xs-right">
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon
      :disabled="
      this.disableEdit ||
      !this.enableDocumentItemEdit() ||
      this.getDetailChar.stat"
      >
        <v-icon :color="ui.btnColor"> create </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor">
          <v-card-title :class="ui.textTitle">
            Edit Attachment
            <v-spacer/>
            {{displayDocumentIDGTypeA(attachment.basic.tag, attachment.basic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row wrap class="mr-2">
                <v-flex xs12>
                  <v-text-field
                    v-model="localFormEdit.title"
                    label="title"
                    :rules="mustBeLessThanSmall"
                    prepend-icon="title"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-select
                    v-model="localFormEdit.theme"
                    :items="attachmentTheme"
                    :label="localFormEdit.theme"
                    prepend-icon="yard"
                    hint="attach. type"
                    required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                    v-model="localFormEdit.type"
                    :items="attachmentType"
                    label="type"
                    prepend-icon="grid_view"
                    hint="attach. type"
                    required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    v-model="localFormEdit.ref"
                    v-if="localFormEdit.theme !== 'Comment'"
                    :rules="ruleMustBeNotUndefinedANDLessThan25"
                    label="reference"
                    prepend-icon="bookmark"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs12>
                  <v-text-field
                    v-model="localFormEdit.link"
                    label="web link / https"
                    :rules="mustBeLessThanLarge"
                    v-if="localFormEdit.theme !== 'Comment'"
                    prepend-icon="link"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <InfoDateAgoName :data="this.attachment.stats"/>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs12>
                  <v-textarea
                  v-model="localFormEdit.com"
                  :disabled="false"
                  :outline="true"
                  required
                  :rules="mustBeLessThanLarge"
                  hint="attachment description"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn @click="closeDialog()" :color="ui.btnColor" flat
            class="hidden-xs-only">
              <v-icon left> exit_to_app </v-icon>
                Close
            </v-btn>
            <v-btn @click="closeDialog()" :color="ui.btnColor" flat
            class="hidden-sm-and-up">
              <v-icon> exit_to_app </v-icon>
            </v-btn>
            <v-spacer/>
            <v-btn @click="deleteAttachment()" color="error"
            flat class="hidden-xs-only"
               :disabled="this.getAttachmentList.length < 1">
              <v-icon left> delete </v-icon>
                Delete
            </v-btn>
            <v-btn @click="deleteAttachment()" color="error"
            flat class="hidden-sm-and-up"
               :disabled="this.getAttachmentList.length < 1">
              <v-icon> delete </v-icon>
            </v-btn>
            <v-btn @click="validate()" :color="ui.btnColor" flat
            class="hidden-xs-only">
              <v-icon left> create </v-icon>
                Update
            </v-btn>
            <v-btn @click="validate()" :color="ui.btnColor" flat
            class="hidden-sm-and-up">
              <v-icon> create </v-icon>
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import master from "@/data/forms/mixins/master.js";
import attachOptions from "@/data/options/mixins/attachOptions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import uisettings from "@/frame/theme/mixins/uisettings.js";
import InfoDateAgoName from "@/frame/display/components/InfoDateAgoName";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import documentFunctions from "@/data/functions/mixins/documentFunctions.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    master,
    attachOptions,
    rulesTextfield,
    dateFunctions,
    uisettings,
    docRevsModFunctions,
    numberFunctions,
    apptheme,
    displayFunctions,
    documentFunctions
  ],
  components: {
    InfoDateAgoName
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getAttachmentList",
      "getUser",
      "getDetailChar",
      "getAttachmentListCounter",
      "getDetailBasic",
      "getPreviousPage"
    ]),
    reactiveAttachmentList() {
      return this.getAttachmentList;
    },
    // selected task item
    selectedAttachmentItem() {
      return this.attachment;
    },
    textTitle() {
      let k = "title";
      let temp = this.ui.textColor + "--text ";
      k = temp + k;
      return k;
    },
    disableEdit() {
      let logic = null;
      if (this.getDetailBasic.tag === "E8") {
        if (
          this.getDetailChar.stat === true ||
          this.getPreviousPage === "/reportlist" ||
          this.getPreviousPage === "/reportdetaillist"
        ) {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        logic = false;
      }
      return logic;
    }
  },
  props: {
    attachment: {
      type: Object
    }
  },
  data() {
    return {
      hideActions: true,
      dialog: false,
      valid: false,
      enableSpinner: false,
      localFormEdit: {
        title: "",
        type: "",
        theme: "",
        link: "",
        ref: "",
        com: ""
      }
    };
  },
  beforeMount() {
    this.localFormEdit.title = this.attachment.basic.title;
    this.localFormEdit.type = this.attachment.char.type;
    this.localFormEdit.theme = this.attachment.char.theme;
    this.localFormEdit.ref = this.attachment.char.ref;
    this.localFormEdit.link = this.attachment.char.link;
    this.localFormEdit.com = this.attachment.char.com;
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
    },
    deleteAttachment() {
      let newList = [];
      let oldList = this.getAttachmentList;
      let idi = this.attachment.basic.idi;
      // loop
      for (var i = 0; i < oldList.length; i++) {
        // eslint-disable-next-line
        if (idi !== oldList[i].basic.idi) {
          // newID = newID + 1;
          // list[i].basic.id = newID;
          // LOGIC TEST
          console.log(idi);
          console.log(oldList[i].basic.idi);
          console.log(newList);
          newList.push(oldList[i]);
        }
      }
      this.$store.dispatch("changeAttachmentList", newList);
      // the below is needed to cater for reactivty bug
      // eslint-disable-next-line
      this.$store.dispatch("changeAttachmentListCounter", this.getAttachmentListCounter + 1);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(5.12, 1); // attachment removed.
      // HELP
      console.log("AttachmentEdit");
      console.log("deleteAttachment");
      console.log(newList);
      // Close dialog
      this.dialog = false;
    },
    validate() {
      // cosole.log(this.taskForm)
      if (this.$refs.form.validate() === true) {
        // hi
        this.$store.dispatch("changeDataSavePendingIndication", true);
        // add dates
        let tempForm = this.attachment;
        // change form
        tempForm.basic.title = this.localFormEdit.title;
        tempForm.char.link = this.localFormEdit.link;
        tempForm.char.ref = this.localFormEdit.ref;
        tempForm.char.com = this.localFormEdit.com;
        tempForm.char.type = this.localFormEdit.type;
        tempForm.char.theme = this.localFormEdit.theme;
        // who added / edited it

        // Ovewrite name / date
        tempForm.stats.date = moment().format();
        // eslint-disable-next-line
        tempForm.stats.uname = this.getUser.basic.title;
        tempForm.stats.uemail = this.getUser.basic.email;
        tempForm.stats.udid = this.getUser.basic.did;

        // current task list
        // console.log(this.getAttachmentList);
        var tempAttachmentList = this.getAttachmentList;
        // eslint-disable-next-line
        tempAttachmentList[this.attachment.basic.id - 1] = this.tempForm;
        // console.log(tempAttachmentList);
        // Submit to store
        this.$store.dispatch("changeAttachmentList", tempAttachmentList);
        // the below is needed to cater for reactivty bug
        // eslint-disable-next-line
        // this.$store.dispatch("changeAttachmentListCounter", this.getAttachmentListCounter + 1);
        this.saveDocumentRevMod(5.13, 2); // attachment removed
        this.$store.dispatch("changeDataSavePendingIndication", true);
        // HELP
        // console.log("AttachmentEdit");
        // console.log("validate");
        // console.log(tempForm);
        // Close Window
        this.dialog = false;
      }
    }
  }
};
</script>
